var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCceLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 203.44",
    style: {
      enableBackground: "new 0 0 595.28 203.44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.53,203.42c28.04,0,53.42-11.36,71.79-29.74l-23.95-23.95c-12.26,12.26-29.18,19.85-47.84,19.85 c-37.32,0-67.69-30.36-67.69-67.69c0-37.32,30.36-67.69,67.69-67.69c18.66,0,35.58,7.59,47.84,19.85l23.95-23.95 c-18.37-18.37-43.76-29.74-71.79-29.74C45.46,0.37,0,45.82,0,101.9C0,157.97,45.46,203.42,101.53,203.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.4,149.76c-21.28,21.27-55.06,26.42-82.17,10.48l-17.15,29.18c40.74,23.95,91.35,16.24,123.26-15.72 L149.4,149.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.74,164.16c2.63-3.4,5.08-7,7.31-10.81l-29.18-17.15c-0.75,1.28-1.54,2.52-2.36,3.74L181.74,164.16z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.27,
    y: 50.25,
    transform: "matrix(0.8621 0.5068 -0.5068 0.8621 78.8032 -87.5238)",
    className: "st1",
    width: 33.84,
    height: 101.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.81,203.42c28.04,0,53.42-11.36,71.79-29.74l-23.95-23.95c-12.26,12.26-29.18,19.85-47.84,19.85 c-37.32,0-67.69-30.36-67.69-67.69c0-37.32,30.36-67.69,67.69-67.69c18.66,0,35.58,7.59,47.84,19.85L369.6,30.1 c-18.37-18.37-43.76-29.74-71.79-29.74c-56.07,0-101.53,45.46-101.53,101.53C196.28,157.97,241.73,203.42,297.81,203.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.67,149.76c-21.28,21.27-55.06,26.42-82.17,10.48l-17.15,29.18c40.74,23.95,91.35,16.24,123.26-15.72 L345.67,149.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M383.82,155.22l-28.46-16.73c-0.2-0.12-0.26-0.37-0.15-0.57l52.44-89.21c0.12-0.2,0.37-0.26,0.57-0.15 l28.46,16.73c0.2,0.12,0.26,0.37,0.15,0.57l-52.44,89.21C384.27,155.27,384.02,155.34,383.82,155.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.97,83.7c-3.07-11.59-9.15-22.18-17.67-30.7c-12.79-12.79-29.95-19.89-48.04-19.89 c-18.06,0-35.76,6.58-48.01,19.89c-12.07,13.12-19.42,30.15-19.86,48.01c-0.45,18.05,7.1,35.21,19.86,48.01 c12.79,12.79,29.95,19.89,48.01,19.89c18.09,0,35.24-7.1,48.04-19.89c1.9-1.9,3.67-3.91,5.33-6.02h38.53v0.03 c-5,10.93-11.95,20.89-20.47,29.41c-18.99,18.99-44.55,29.59-71.42,29.59c-26.88,0-52.4-10.59-71.42-29.59 c-18.99-19.02-29.56-44.55-29.56-71.42c0-26.88,10.56-52.43,29.56-71.42C441.87,10.57,467.39,0,494.27,0 c26.88,0,52.43,10.56,71.42,29.59c19.02,18.99,29.59,44.54,29.59,71.42c0,4.67-0.3,9.36-0.96,14l-0.45,3.28h-72.72h-30.67V83.7 H559.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.07,164.16c2.63-3.4,5.08-7,7.31-10.81l-29.18-17.15c-0.75,1.28-1.54,2.52-2.36,3.74L378.07,164.16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCceLogoWhite);
export default __webpack_public_path__ + "static/media/CCE_logo_white.91e3fbf57ad41e8faff0cadf946f56db.svg";
export { ForwardRef as ReactComponent };